<div class="main-container">
  <div class="application-status-container">
    <div id="name-button-container">
      <span id="login-user" class="seneca-dark-grey">Welcome {{ name }}!</span>

      <button
        class="seneca-button"
        id="applicationBtn"
        *ngIf="!hideApplicationButton"
        on-click="goToIwaApp()"
        mat-flat-button
        color="primary"
      >
        <span>International Online Application</span>
      </button>
    </div>
    <app-iap-applications> </app-iap-applications>
  </div>

  <div class="announcement-container">
    <mat-card class="mat-card-bottom">
      <mat-accordion class="example-headers-align">
        <div class="mat-card-bottom-content">
          <mat-card-title>
            <h1 class="card-title">Announcements</h1>
          </mat-card-title>
          <p class="card-sentence seneca-dark-grey">
            As a valued part of our Seneca family we wish to inform you of some
            important updates:
          </p>
          <mat-card-content>
            <mat-expansion-panel
              *ngFor="let element of ELEMENT_DATA; first as isFirst"
              [expanded]="isFirst"
            >
              <mat-expansion-panel-header
                [collapsedHeight]="'unset'"
                [expandedHeight]="'unset'"
              >
                <mat-panel-title>
                  {{ element.Title }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="collapse-card-content">
                <p class="seneca-dark-grey">
                  POSTED: {{ element.PublishedFrom | date : "mediumDate" }}
                </p>
                <!-- <div [innerHTML]="element.AnnouncementContent | sanitizeHtml"></div> -->
                <div class="ql-container ql-snow" style="border-width: 0">
                  <div
                    class="ql-editor"
                    [innerHTML]="element.AnnouncementContent | sanitizeHtml"
                  ></div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-card-content>
        </div>
      </mat-accordion>
    </mat-card>
  </div>
</div>
